import { render, staticRenderFns } from "./CreateOrderFlatRate.vue?vue&type=template&id=01665046&lang=pug&"
import script from "./CreateOrderFlatRate.vue?vue&type=script&lang=ts&"
export * from "./CreateOrderFlatRate.vue?vue&type=script&lang=ts&"
import style0 from "./CreateOrderFlatRate.vue?vue&type=style&index=0&id=01665046&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports